import React from 'react';
import { AlertPriority } from '../../types/admin';
import styles from './AlertPriorityBadge.module.css';

const PRIORITY_VARIANT: Record<string, string> = {
  [AlertPriority.LOW]:    'low',
  [AlertPriority.MEDIUM]: 'medium',
  [AlertPriority.HIGH]:   'high',
  [AlertPriority.URGENT]: 'urgent',
};

const PRIORITY_LABEL: Record<string, string> = {
  [AlertPriority.LOW]:    'Baja',
  [AlertPriority.MEDIUM]: 'Media',
  [AlertPriority.HIGH]:   'Alta',
  [AlertPriority.URGENT]: 'Urgente',
};

interface AlertPriorityBadgeProps {
  priority: AlertPriority;
}

const AlertPriorityBadge: React.FC<AlertPriorityBadgeProps> = ({ priority }) => {
  const variant = PRIORITY_VARIANT[priority] ?? 'medium';
  const label   = PRIORITY_LABEL[priority]   ?? priority;
  return (
    <span className={`${styles.badge} ${styles[`badge--${variant}`]} uc-status`}>
      {label}
    </span>
  );
};

export default AlertPriorityBadge;
